export default __webpack_public_path__ + "static/media/gdgLogo.5aa86d0c.bmp";